import { h } from 'preact'
import { tagParser } from '../../js/modules/utilities'

export const TuileEscda = ({ title, subtitle, image, alt, CTA: { URL, analytics, label } }) => {
   return (
      <a
         href={URL}
         data-pdb-zid={analytics.pdbZid}
         data-pdb-sc={analytics.pdbSc}
         data-pdb-idc={analytics.pdbIdc}
         data-pdb-vi={analytics.pdbVi}
         data-pdb-ta={analytics.pdbTa}
         data-adv-canal={analytics.advCanal}
         data-adv-cappingdata={analytics.advCappingdata}
         data-oevent-category={analytics.oeventCategory}
         data-oevent-action={analytics.oeventAction}
         data-oevent-label={analytics.oeventLabel}
         data-oevent-other={analytics.oeventOther}
         class="tuile-escda lien-composite-before"
      >
         <div class="content">
            <img class="image mb-2" src={image} alt={alt || ''} loading="lazy" />
            <h3 class="h4 m-0 p-0">
               <strong class="title" dangerouslySetInnerHTML={{ __html: tagParser(title) }} />
               <span class="subtitle" dangerouslySetInnerHTML={{ __html: tagParser(subtitle) }} />
            </h3>
         </div>
         <span class="o-link-arrow">{label}</span>
      </a>
   )
}
